// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format11 } from '../../constants';

/** Timor-Leste */
const TL: PhoneNumberData = [670, 'TL', 8, format11];

export default TL;
